import ISessionStorages from './sessionStorage.types';

export const getKey = (key: string) => `__${key}`;

export const setSessionStorage = <T extends keyof ISessionStorages>(
  key: T,
  value: ISessionStorages[T]
) => {
  return window.sessionStorage.setItem(getKey(key), JSON.stringify(value));
};

export const getSessionStorage = <T extends keyof ISessionStorages>(
  key: T
): ISessionStorages[T] | null => {
  try {
    return JSON.parse(window.sessionStorage.getItem(getKey(key)) as string);
  } catch (e) {
    return null;
  }
};

export const removeSessionStorage = <T extends keyof ISessionStorages>(
  key: T
) => {
  return window.sessionStorage.removeItem(getKey(key));
};
